/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon16Solid = forwardRef('NetConnectRssIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.665 4.99a7.5 7.5 0 0 0-3.106-.477 1 1 0 1 1-.118-1.997 9.5 9.5 0 0 1 10.042 10.045 1 1 0 1 1-1.996-.118A7.5 7.5 0 0 0 6.665 4.99Z" }),
        React.createElement("path", { d: "M5.158 8.697a3.5 3.5 0 0 0-1.55-.175 1 1 0 0 1-.223-1.988 5.5 5.5 0 0 1 6.08 6.09 1 1 0 0 1-1.988-.227 3.5 3.5 0 0 0-2.32-3.7Z" }),
        React.createElement("path", { d: "M4 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })));
});
